import Header from "@/reusable_sections/Header";
import PageHero from "@/components/PageHero";
import ServiceIntro from "@/components/service/ServiceIntro";
import ServiceCards from "@/components/service/ServiceCards";
import PowerWashingQuote from "./sections/PowerWashingQuote";
import OtherServices from "@/components/service/OtherServices";
import CtaBand from "@/components/CtaBand";
import Footer from "@/reusable_sections/Footer";
import { Sparkles, Home, Shield, TreePine, Building2 } from "lucide-react";
const subServices = [{
  title: "Driveway & Patio Cleaning",
  description: "Deep cleaning and pressure washing for block paving, natural stone patios, concrete slabs, and resin-bound driveways to remove moss, algae, and grime.",
  icon: Sparkles
}, {
  title: "Decking Restoration",
  description: "Specialist cleaning for wooden decking and composite boards, eliminating slippery organic buildup and restoring natural timber warmth safely.",
  icon: Home
}, {
  title: "Moss & Lichen Removal",
  description: "High-pressure and biocidal washing techniques targeting stubborn black spot lichen, invasive moss, and environmental stains on exterior surfaces.",
  icon: TreePine
}, {
  title: "Façade & Commercial Cleaning",
  description: "Complete exterior wall and building façade washing for residential and commercial premises across Southampton, Hampshire & surrounding areas.",
  icon: Building2
}, {
  title: "Surface Protection & Sealing",
  description: "Long-lasting protective sealing treatments following deep cleans to deter future weed growth, oil penetration, and weather-induced surface deterioration.",
  icon: Shield
}];
export default function PowerWashingPage() {
  return <div className="min-h-screen bg-background text-foreground flex flex-col">
      <Header />

      <PageHero breadcrumbLabel="Power Washing" breadcrumbParent={{
      label: "Services",
      to: "/ServicesHubPage"
    }} eyebrow="OUR SERVICES" title="Power Washing in Southampton" intro="Restore the brilliance of your outdoor spaces with our expert power washing solutions for driveways, patios, and decking across Southampton, Hampshire & surrounding areas." imageSrc="https://qualityroofsandlandscapes.co.uk/wp-content/uploads/2026/05/pressure-washing.jpg?v=re1w5o4ptz" imageAlt="Professional power washing in Southampton by Firststop Roofing Ltd" actions={true} />

      <ServiceIntro eyebrow="PROFESSIONAL EXTERIOR CARE" heading="Expert Power Washing & Exterior Cleaning in Southampton" paragraphs={["Restore the pristine look of your property with our trusted power washing services in Southampton. From deep-cleaning driveways and restoring weathered patios to revitalising building façades, our roofing and property specialists use industrial-grade rotary cleaners to remove stubborn grime, algae, and lichen safely without damaging exterior surfaces.", "Every project is completed by Matt and our experienced team with calibrated pressure and specialist surface care to deliver uniform, streak-free results across Southampton, Hampshire & surrounding areas."]} benefits={["Deep cleaning of driveways, patios, and exterior masonry", "Complete restoration of wooden decking and walkways", "Removal of stubborn moss, lichen, and black spot staining"]} imageSrc="https://qualityroofsandlandscapes.co.uk/wp-content/uploads/2026/05/man-washing-driveway.jpg" imageAlt="High-pressure driveway cleaning in Southampton by Firststop Roofing Ltd" cta={true} />

      <ServiceCards eyebrow="WHAT WE OFFER" heading="Our Southampton Power Washing Services" intro="Comprehensive high-pressure washing and exterior cleaning solutions tailored to protect and rejuvenate your outdoor surfaces across Southampton, Hampshire & surrounding areas." items={subServices} columns={3} />

      <PowerWashingQuote />

      <OtherServices currentKey="power-washing" />

      <CtaBand />

      <Footer />
    </div>;
}